import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faClockRotateLeft, faCube, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons';


export default function Sidebar() {

    const location = useLocation();
    const navigate = useNavigate();

    const Sidebarnav = [
        { id: 'div1', label: 'Dashboard', icon: faCube, path: '/admin/dashboard' },
        { id: 'div2', label: 'Users', icon: faUser, path: '/admin/user' },
        { id: 'div3', label: 'Reports', icon: faFileAlt, path: '/admin/report' },
        // { id: 'div4', label: 'Notifications', icon: faClockRotateLeft, path: '/admin/notifications' },
    ];

    const [openToggle, setopenToggle] = useState(false)

    const handleOpentoggle = () => {
        setopenToggle(!openToggle)
    }

    const Logout = async () => {
        sessionStorage.removeItem('admin_token');
        navigate("/admin/login");
    }

    return (
        <>
            <div className='hidden lg:block lg:w-[20%] px-2 py-5 relative h-full'>
                <div className='h-full grid content-between'>
                    <div className='space-y-2 mt-3'>
                        {Sidebarnav.map((item) => {
                            const isActive = location.pathname === item.path;
                            return (
                                <Link to={item.path} key={item.id}>
                                    <button
                                        className={`w-full flex items-center gap-3 pl-14 pr-4 py-2
                                            ${isActive ? ' bg-white/10 text-white rounded-md' : ' text-gray-300'}`}>
                                        <FontAwesomeIcon icon={item.icon} className="text-lg text-[#5C1FE2]" />
                                        <span className="font-medium">{item.label}</span>
                                    </button>
                                </Link>
                            );
                        })}
                    </div>
                    <div className='flex justify-center'>
                        <button onClick={() => { Logout() }} className='text-white cursor-pointer bg-white/25 px-4 py-2 rounded-lg'><FontAwesomeIcon icon={faRightFromBracket} className='mr-3' /> Logout</button>
                    </div>
                </div>
            </div>
            <div className='block lg:hidden'>
                <div className={`duration-500 w-[100%] px-2 relative ${openToggle ? 'max-h-[500px] py-5' : 'max-h-0 overflow-hidden'}`}>
                    <div>
                        <div>
                            <div className='space-y-2 mt-3'>
                                {Sidebarnav.map((item) => {
                                    const isActive = location.pathname === item.path;
                                    return (
                                        <Link to={item.path} key={item.id}>
                                            <button
                                                className={`w-full flex items-center gap-5 pl-14 pr-4 py-2
                                            ${isActive ? ' bg-white/10 text-white rounded-md' : ' text-gray-500'}`}>
                                                <FontAwesomeIcon icon={item.icon} className="text-lg text-[#5C1FE2]" />
                                                <span className="font-medium">{item.label}</span>
                                            </button>
                                        </Link>
                                    );
                                })}
                            </div>
                        </div>
                        <div className='flex justify-center mt-3'>
                            <button onClick={() => { Logout() }} className='text-white cursor-pointer bg-[#D9D9D961] px-4 py-2 rounded-lg'><FontAwesomeIcon icon={faRightFromBracket} className='mr-3' /> Logout</button>
                        </div>
                    </div>
                </div>
                <div className='px-3 py-3'>
                    <div className='flex flex-col gap-1' onClick={handleOpentoggle}>
                        <div className={`w-7 h-[2px] bg-white duration-500 ${openToggle ? 'rotate-45 translate-y-1.5' : ''}`}></div>
                        <div className={`w-7 h-[2px] bg-white duration-500 ${openToggle ? '-rotate-45' : ''}`}></div>
                    </div>
                </div>
            </div>
        </>
    )
}
